// device-utils.ts

export interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  os: string;
  browser: string;
  userAgent: string;
}

export function getDeviceInfo(): DeviceInfo {
  const ua = navigator.userAgent;

  const isTablet = /iPad|Tablet|PlayBook|Silk|Kindle|Nexus 7|Nexus 10|SM-T|GT-P/i.test(ua);
  const isMobile = /Mobi|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) && !isTablet;
  const isDesktop = !isMobile && !isTablet;

  const os = (() => {
    if (/Windows NT/.test(ua)) return 'Windows';
    if (/Mac OS X/.test(ua)) return 'macOS';
    if (/Android/.test(ua)) return 'Android';
    if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
    if (/Linux/.test(ua)) return 'Linux';
    return 'Unknown';
  })();

  const browser = (() => {
    if (/Edge\/\d+/.test(ua)) return 'Edge';
    if (/OPR\//.test(ua)) return 'Opera';
    if (/Chrome\//.test(ua)) return 'Chrome';
    if (/Safari\//.test(ua)) return 'Safari';
    if (/Firefox\//.test(ua)) return 'Firefox';
    if (/MSIE|Trident/.test(ua)) return 'IE';
    return 'Unknown';
  })();

  return {
    isMobile,
    isTablet,
    isDesktop,
    os,
    browser,
    userAgent: ua
  };
}
